import { useRef, useState } from "react";

//Components
import { MenuOptions } from "../menu-option";

//Styles
import { Dots } from "../../styles/users";

export const RowDots = ({ options, optionsFns }) => {
   const [rowMenuVisibility, setRowMenuVisibility] = useState(false);
   const rowMenuRef = useRef(null);

   return (
      <div
         style={{ position: "relative" }}
         ref={rowMenuRef}
         tabIndex={0}
         role="button"
         onClick={() => setRowMenuVisibility(!rowMenuVisibility)}
         onKeyDown={() => setRowMenuVisibility(!rowMenuVisibility)}
      >
         <Dots />
         <MenuOptions
            left="-120px"
            top="-72px"
            ref={rowMenuRef}
            visible={rowMenuVisibility}
            onClose={() => setRowMenuVisibility(false)}
            options={options}
            optionsFns={optionsFns}
         />
      </div>
   );
};

